import { isUndefined, isNull, isEmpty } from 'lodash';
import size from 'lodash/size';

export const convertISOToDateTime = str => {
  return new Date(str);
};
export const getDate = str => {
  if (isNull(str) || isUndefined(str)) return null;
  return str.split('T')[0];
};

export const getDateInPST = str => {
  return isNull(str) || isUndefined(str)
    ? null
    : convertISOToDateTime(str).toLocaleDateString('en-US', { timeZone: 'America/Los_Angeles' });
};
export const getDateTime = str => {
  return isNull(str) || isUndefined(str)
    ? null
    : convertISOToDateTime(str).toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
};

const getToken = str => {
  if (size(str.toString()) < 2) return `0${str}`;
  return str;
};

export const getDateInYYYYMMDDFormat = str => {
  if (isEmpty(str)) return null;
  const date = getDateTime(str);
  const transformDate = new Date(str);
  return `${transformDate.getFullYear()}-${getToken(transformDate.getMonth() + 1)}-${getToken(
    transformDate.getDate(),
  )}, ${date.split(',')[1]} PST`;
};

export const getDateInMMDDYYYYHHMIFormat = str => {
  if (isEmpty(str)) return '-';
  const dateTime = getDateTime(str);
  const transformDate = new Date(str);
  // eslint-disable-next-line
  const [day, month, date, year, time, timeZone] = transformDate.toString().split(' ');
  return `${month} ${date}, ${year} at ${dateTime.split(',')[1]} PT`;
};
